class ContractsService {
	constructor($http) {
		'ngInject';
		this.http = $http;
	}

	onlineContract() {
		return this.http({
			method: 'GET',
			url: 'https://www.otpebiz.hu/wp-json/wp/v2/pages/552',
			headers: {'RelationshipId': undefined, 'Version': undefined}
		});
	}

	generalContract() {
		return this.http({
			method: 'GET',
			url: 'https://www.otpebiz.hu/wp-json/wp/v2/pages/37',
			headers: {'RelationshipId': undefined, 'Version': undefined}
		});
	}

	dataContract() {
		return this.http({
			method: 'GET',
			url: 'https://www.otpebiz.hu/wp-json/wp/v2/pages/43',
			headers: {'RelationshipId': undefined, 'Version': undefined}
		});
	}

	bankSecrecyContract() {
		return this.http({
			method: 'GET',
			url: 'https://www.otpebiz.hu/wp-json/wp/v2/pages/1283',
			headers: {'RelationshipId': undefined, 'Version': undefined}
		});
	}
}

export default ContractsService;
